import React, { Component } from "react";

import { CSpinner } from "@coreui/react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { logout } from "../../actions/baseActions";
import URL from "../../config/api";
import axios from "../../config/axios";
import ApplicatedQuestion from "../ApplicatedQuestion/ApplicatedQuestion";
// import { log } from '../../utils/log';

import "./style.css";

class ApplicatedTvQuestionList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allocationId: this.props.allocationId,
      activityId: this.props.activityId,
      listId: this.props.id,
      loading: true,
      loadingAnswers: false,
      // prototype: this.props.prototype,
      finished: false,
      corrected: false,

      name: undefined,
      questions: [],
      // simulated: false,
      // random: false,
      // time: null,
      start: { fullDate: undefined, timeStamp: undefined },
      // end: undefined,
      // value: null,
      // executions: 0,
      // randomizer: [],
      types: [],

      answers: {
        score: 0,
        scoreValue: 0,
        answers: []
      }
    };

    this.listAswerChanger = this.changeListAnswers.bind(this);
    this.showAnswers = this.showAnswers.bind(this);
  }

  componentDidMount() {
    const startMark = this.getCurrentDate();
    this.setState({
      start: { fullDate: startMark.currentTime, timeStamp: startMark.timeStamp }
    });

    this.pullList();
  }

  pullList() {
    axios
      .get(`${URL.api}evaluation/type_question/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.setState({ types: resp.data.data });
      });

    axios
      .get(
        `${URL.api}evaluation/question/lists/singleViewWithOptions/${this.state.listId}`,
        { headers: { authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(resp => {
        if (resp.data.success) {
          const answersDataObj = {
            textAnswer: "Sem resposta",
            itemsAnswer: []
          };

          const questionsArray = resp.data.data?.questions.map(question => ({
            id: question.id,
            value: question.value
          }));
          const answersArray = resp.data.data?.questions.map(answer => ({
            questionId: answer.id,
            correction: false,
            answer: answersDataObj,
            value: answer.value
          }));

          this.setState({
            listId: resp.data.data.id,
            name: resp.data.data.name,
            questions: resp.data.data?.questions,
            // simulated: resp.data.data.simulated,
            // random: resp.data.data.random,
            // time: resp.data.data.time,
            // value: resp.data.data.value,
            // currentValueSum: resp.data.data.value,
            // executions: resp.data.data.execution_quantity,
            // randomizer: resp.data.data.randoms,

            answers: {
              score: 0,
              scoreValue: 0,
              answers: answersArray
            },

            loading: false
          });
        }
      });
  }

  getCurrentDate() {
    const timeStamp = new Date().getTime();

    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1;
    const currentDay = new Date().getDate();
    const currentHour = new Date().getHours();
    const currentMinute = new Date().getMinutes();
    const currentSecond = new Date().getSeconds();

    const fullDate = `${currentYear}-${currentMonth}-${currentDay} ${currentHour}:${currentMinute}:${currentSecond}`;

    const timeSpent = Math.floor(
      (timeStamp - this.state.start.timeStamp) / 60000
    );

    return { currentTime: fullDate, timeStamp, timeSpent };
  }

  changeListAnswers(questionId, correctionValue, answerData) {
    const correctionsArray = this.state.answers.answers.slice();
    const answerIndex = correctionsArray.findIndex(
      answer => answer.questionId === questionId
    );

    correctionsArray[answerIndex].correction = correctionValue;
    correctionsArray[answerIndex].answer = answerData;

    const newScore = this.sumUserScore(correctionsArray);
    const answersArray = {
      score: newScore.rawValue,
      scoreValue: Number(newScore.finalValue),
      answers: correctionsArray
    };

    this.setState({ answers: answersArray });
  }

  showAnswers() {
    return true;
  }

  sumUserScore(newAnswersArray) {
    const answersArray = newAnswersArray.slice();
    const correctedValuesArray = answersArray
      .filter(answer => answer.correction)
      .map(answer => Number(answer.value));
    const rawValue = correctedValuesArray.length;
    const finalValue = correctedValuesArray.reduce((a, b) => a + b, 0);

    return { rawValue, finalValue };
  }

  finishListApplication() {
    this.setState({ loadingAnswers: true });
    if (this.props.prototype) return;

    const timer = {
      start: this.state.start.fullDate,
      end: this.getCurrentDate().currentTime,
      spent: this.getCurrentDate().timeSpent
    };

    const answersArray = this.state.answers.answers.map(answer => ({
      question_id: answer.questionId,
      start: timer.start,
      end: timer.end,
      answer: JSON.stringify(answer.answer),
      correct: answer.correction,
      time_spent: timer.spent / this.state.answers.answers.length,
      value: Number(answer.value)
    }));

    const obj = {
      allocation_id: this.state.allocationId,
      activity_id: this.state.activityId,
      execution_id: this.props.execution_id,
      item_id: this.props.item_id,
      list_id: this.state.listId,
      user_id: this.props.user.user.id,
      start: timer.start,
      end: timer.end,
      time_spent: timer.spent,
      correct_answers: this.state.answers.score,
      final_grade: this.state.answers.scoreValue,
      average_question_time: timer.spent / answersArray.length,
      try: 1,
      answers: answersArray
    };

    axios
      .post(`${URL.api}evaluation/application/insert`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(() => {
        this.setState({ loadingAnswers: false, finished: true });
      });
  }

  render() {
    return (
      <>
        {!this.state.loading ? (
          <>
            {!this.state.corrected ? (
              <div className="container my-3">
                <h2>{this.state.name}</h2>
                <section className="mt-4">
                  {this.state?.questions.map((question, index) => (
                    <ApplicatedQuestion
                      questionOrder={index + 1}
                      id={question.id}
                      typeId={question.type_question_id}
                      questionDescription={question.description}
                      grade={question.grade}
                      author={question.author}
                      year={question.year}
                      difficultyLevel={question.difficulty_level_id}
                      options={question.options}
                      questionFeedback={question.feedback}
                      // feedback={}
                      questionId={question.id}
                      listId={this.state.listId}
                      prototype={false}
                      listApplication
                      finished={this.state.finished}
                      history={this.props.history}
                      listAswerChanger={this.listAswerChanger}
                      types={this.state.types}
                      userAnswer={
                        this.state?.answers.answers.find(
                          answer => answer.questionId === question.id
                        )?.answer
                      }
                      showAnswers={this.showAnswers}
                    />
                  ))}
                </section>
                <section className="applicated-tv-question-list-navigation-menu">
                  {this.state.finished ? (
                    <button
                      disabled={this.state.loadingAnswers}
                      className="btn btn-block btn-success p-3 d-flex align-items-center justify-content-center"
                      onClick={() => this.setState({ corrected: true })}
                    >
                      <span
                        style={
                          this.state.loadingAnswers ? { opacity: 0 } : null
                        }
                      >
                        Continuar
                      </span>
                      {this.state.loadingAnswers && (
                        <CSpinner
                          size="sm"
                          color="white"
                          style={{ position: "absolute" }}
                        />
                      )}
                    </button>
                  ) : (
                    <button
                      disabled={this.state.loadingAnswers}
                      className="btn btn-block btn-primary p-3 d-flex align-items-center justify-content-center"
                      onClick={() => this.finishListApplication()}
                    >
                      <span
                        style={
                          this.state.loadingAnswers ? { opacity: 0 } : null
                        }
                      >
                        Concluir
                      </span>
                      {this.state.loadingAnswers && (
                        <CSpinner
                          size="sm"
                          color="white"
                          style={{ position: "absolute" }}
                        />
                      )}
                    </button>
                  )}
                </section>
              </div>
            ) : (
              <div className="applicated-tv-question-list-loading-container container">
                <h3 className="text-center">
                  Sua avaliação foi finalizada, todos os dados foram salvos e
                  enviados para a correção!
                </h3>
              </div>
            )}
          </>
        ) : (
          <div className="applicated-tv-question-list-loading-container">
            <CSpinner color="secondary" size="md" />
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ApplicatedTvQuestionList);
